module.exports = "data:image/gif;base64,R0lGODlhCQAPALMNAEVFRf///6urq+3t7aOjo7S0tNHR0d3d3fLy8rq6uqWlpcPDw8XFxf///wAAAAAAACH5BAEAAA0ALAAAAAAJAA8AAAQ3sMlJq7VHaKUIWUIgisgAhCJQGucIDEcCKAFg2zIRlMBhFABC6QAwMICEgTFRaAIWt+jiQq1OIgA7"


/*****************
 ** WEBPACK FOOTER
 ** ./extjs/resources/themes/images/gray/grid/group-expand.gif
 ** module id = 183
 ** module chunks = 0
 **/